import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { searchCourseByTitle, searchSectionByTitle } from 'actions/search';
import { getSchoolByGroupGraphId } from 'actions/sections';
import { debounce } from 'helpers/content';
import schoolHandling from 'helpers/schoolHandling';
import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import AsyncSelect from 'react-select/async';
import Select from 'react-select';
import { reduxForm } from 'redux-form';
import { Spinner } from 'UI';
import { Button } from '@haldor/ui';
import { informAboutTabData } from 'actions/sections';
import api from 'lib/api';
import * as microsoftTeams from "@microsoft/teams-js";
import Onboarding from 'containers/Onboarding/Onboarding';

var SchoolSettingsForm = /*#__PURE__*/function (_Component) {
  _inherits(SchoolSettingsForm, _Component);

  var _super = _createSuper(SchoolSettingsForm);

  function SchoolSettingsForm(props) {
    var _this;

    _classCallCheck(this, SchoolSettingsForm);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      microsoftTeams.app.getContext().then(function (context) {
        _this.props.getSchoolByGroupGraphId(context.team.groupId).then(function () {
          if (_this.props.graphGroupSchool != null) {
            _this.setState({
              school: _this.props.graphGroupSchool.id
            });
          }
        });

        var group = {
          title: context.team.displayName,
          graphId: context.team.groupId
        };

        _this.setState({
          group: group,
          disableGroupInput: true
        });
      });

      if (_this.props.currentUser != null) {
        var currentUser = _this.props.currentUser;

        if (currentUser.schools != null && currentUser.schools.length == 1) {
          _this.selectSchool(currentUser.schools[0]);

          _this.setState({
            hideSchoolInput: true
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "submit", function (values) {
      return new Promise(function (resolve) {
        var courses = [];

        if (_this.state.courses != null && _this.state.courses.length > 0) {
          _this.state.courses.forEach(function (extraCourse) {
            var duplicated = courses.find(function (dupe) {
              return dupe.id == extraCourse.value;
            });

            if (duplicated == null) {
              courses.push({
                id: extraCourse.value
              });
            }
          });
        }

        values.title = _this.state.group.label;
        values.graphId = _this.state.group.value;
        values.type = _this.state.groupType;
        values.courses = courses;
        values.schoolId = _this.state.school.value;
        values.description = '';
        api.post('sections', values).then(function (response) {
          if (values.schoolId != 0) {
            schoolHandling.setSchoolOnUser(_this.props.currentUser, values.schoolId);
          }

          _this.props.informAboutTabData(_this.state.group.value, 'HALDOR_PLANNING');

          if (_this.props.onSubmit != null) {
            _this.props.onSubmit(response.data).then(function () {
              resolve(1);
            });
          } else {
            resolve(1);
          }
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSearchExtraCourse", function (title, callback) {
      if (!title) {
        callback([]);
      } else {
        var searchValue = title.trim();
        searchValue = searchValue.replace(/[^A-Za-z0-9åäöÅÄÖ ]/g, "");
        searchValue = encodeURIComponent(searchValue);

        if (searchValue.length < 3) {
          callback([]);
          return false;
        }

        if (searchValue != null && searchValue != "") {
          _this.props.searchCourseByTitle(searchValue, function (data) {
            var options = [];
            data.forEach(function (course) {
              var title = "";

              if (course.typeOfSchooling != null) {
                var typeOfSchool = _this.props.translate(course.typeOfSchooling);

                if (typeOfSchool.indexOf("Missing") == -1) {
                  title = "".concat(course.title, " ").concat(course.year != null ? course.year : '', " (").concat(_this.props.translate(course.typeOfSchooling), ") (").concat(course.courseCode, ")");
                } else {
                  title = "".concat(course.title, " ").concat(course.year != null ? course.year : '', " (").concat(course.courseCode, ")");
                }
              } else {
                title = "".concat(course.title, " ").concat(course.year != null ? course.year : '', " (").concat(course.courseCode, ")");
              }

              options.push({
                value: course.id,
                label: title
              });
            });
            callback(options);
          });
        } else {
          callback([]);
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onSearchSection", function (title, callback) {
      if (!title) {
        callback([]);
      } else {
        var searchValue = title.trim();
        searchValue = searchValue.replace(/[^A-Za-z0-9åäöÅÄÖ ]/g, "");
        searchValue = encodeURIComponent(searchValue);

        if (searchValue.length < 3) {
          callback([]);
          return false;
        }

        if (searchValue != null && searchValue != "") {
          _this.props.searchSectionByTitle(searchValue, true, function (data) {
            var options = [];
            data.forEach(function (section) {
              options.push({
                value: section.graphId,
                label: section.title
              });
            });
            callback(options);
          });
        } else {
          callback([]);
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "exitOnboarding", function () {
      return _this.setState({
        onboarding: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSectionChange", function (option) {
      _this.setState({
        group: option
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onExtraCourseChange", function (option) {
      _this.setState({
        courses: option
      });
    });

    _defineProperty(_assertThisInitialized(_this), "selectSchool", function (option) {
      _this.setState({
        school: option
      });
    });

    var onboarding = false;

    if (props.onboarding) {
      onboarding = props.onboarding;
    }

    _this.state = {
      courses: [],
      group: null,
      school: null,
      disableGroupInput: false,
      hideSchoolInput: false,
      groupType: 'EDUCATION_GROUP',
      onboarding: onboarding,
      steps: [{
        target: '#school-input',
        content: props.translate('groupconfig-explain-school'),
        disableBeacon: true
      }, {
        target: '#course-input',
        content: props.translate('groupconfig-explain-courses'),
        disableBeacon: true
      }, {
        target: '#teams-header-actions',
        content: props.translate('groupconfig-explain-cog'),
        disableBeacon: true
      }]
    };
    return _this;
  }

  _createClass(SchoolSettingsForm, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          handleSubmit = _this$props.handleSubmit,
          submitting = _this$props.submitting;
      return /*#__PURE__*/React.createElement("div", {
        className: "form-container"
      }, this.state.onboarding ? /*#__PURE__*/React.createElement(Onboarding, {
        steps: this.state.steps,
        onExit: this.exitOnboarding,
        onboarding: this.state.onboarding
      }) : null, /*#__PURE__*/React.createElement("form", {
        onSubmit: handleSubmit(this.submit),
        className: "form form-component"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("label", null, this.props.translate('section')), /*#__PURE__*/React.createElement("div", {
        className: "select"
      }, /*#__PURE__*/React.createElement(Select, {
        isDisabled: this.state.disableGroupInput,
        isSearchable: true,
        name: "section",
        value: this.state.group,
        loadOptions: debounce(this.onSearchSection, 700),
        onChange: function onChange(value) {
          return _this2.onSectionChange(value);
        },
        placeholder: this.props.translate('search-for-a-group'),
        className: "simple-select",
        multi: false,
        ignoreAccents: false,
        ignoreCase: true,
        noOptionsMessage: function noOptionsMessage() {
          return _this2.props.translate('no-results');
        },
        loadingMessage: function loadingMessage() {
          return _this2.props.translate('loading') + '...';
        }
      }))), !this.state.hideSchoolInput ? /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("label", null, this.props.translate('school')), /*#__PURE__*/React.createElement("div", {
        id: "school-input"
      }, /*#__PURE__*/React.createElement(Select, {
        isDisabled: this.props.graphGroupSchool != null,
        type: "schools",
        placeholder: this.props.translate('pick-a-school'),
        labelKey: "title",
        valueKey: "id",
        selectedValue: this.state.school,
        value: this.state.school,
        options: this.props.currentUser.schools,
        onChange: this.selectSchool
      }))) : null, /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("label", null, this.props.translate('courses-header-overview')), /*#__PURE__*/React.createElement("div", {
        id: "course-input",
        className: "select"
      }, /*#__PURE__*/React.createElement(AsyncSelect, {
        isSearchable: true,
        isMulti: true,
        name: "extra-courses",
        value: this.state.courses,
        loadOptions: debounce(this.onSearchExtraCourse, 700),
        onChange: function onChange(value) {
          return _this2.onExtraCourseChange(value);
        },
        placeholder: this.props.translate('search-for-courses'),
        className: "simple-select",
        valueKey: "id",
        labelKey: "title",
        ignoreAccents: false,
        isLoading: false,
        ignoreCase: true,
        trimFilter: true,
        noOptionsMessage: function noOptionsMessage() {
          return _this2.props.translate('no-results');
        },
        loadingMessage: function loadingMessage() {
          return _this2.props.translate('loading') + '...';
        }
      }))), /*#__PURE__*/React.createElement("div", {
        className: "form-divider"
      }), /*#__PURE__*/React.createElement("div", {
        className: "form-row spacing submit"
      }, /*#__PURE__*/React.createElement(Button, {
        style: {
          marginBottom: '25px'
        },
        disabled: submitting || this.state.school == null
      }, this.props.translate('save'), submitting ? /*#__PURE__*/React.createElement(Spinner, {
        center: true,
        small: true
      }) : null)), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      })));
    }
  }]);

  return SchoolSettingsForm;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    currentUser: state.user.currentUser,
    graphGroupSchool: state.sections.graphGroupSchool
  };
}

export default connect(mapStateToProps, {
  searchCourseByTitle: searchCourseByTitle,
  getSchoolByGroupGraphId: getSchoolByGroupGraphId,
  searchSectionByTitle: searchSectionByTitle,
  informAboutTabData: informAboutTabData
})(reduxForm({
  form: 'SchoolSettings',
  destroyOnUnmount: true
})(SchoolSettingsForm));